"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IcatuPersonMaritialStatus = void 0;
var IcatuPersonMaritialStatus;
(function (IcatuPersonMaritialStatus) {
    IcatuPersonMaritialStatus["Single"] = "Solteiro";
    IcatuPersonMaritialStatus["Married"] = "Casado";
    IcatuPersonMaritialStatus["Divorced"] = "Divorciado";
    IcatuPersonMaritialStatus["Widow"] = "Viuvo";
    IcatuPersonMaritialStatus["LegallyDivorced"] = "SeparadoJudicialmente";
    IcatuPersonMaritialStatus["ActuallyDivorced"] = "SeparadoDeFato";
    IcatuPersonMaritialStatus["Other"] = "Outros";
})(IcatuPersonMaritialStatus = exports.IcatuPersonMaritialStatus || (exports.IcatuPersonMaritialStatus = {}));
//# sourceMappingURL=IcatuPersonMaritialStatus.js.map